export const FILE_HEADER_SIZE = 3600
export const TEXTUAL_FILE_HEADER_SIZE = 3200
export const BINARY_FILE_HEADER_SIZE = 400
export const TEXTUAL_FILE_HEADER_ROW_SIZE = 80
export const NUMBER_OF_SAMPLES_PER_DATA_TRACE_FOR_ORIGINAL_FIELD_OFFSET = 24
export const DEFAULT_DATASAMPLEFORMATCODESIZE = 4
export const SAMPLE_INTERVAL_OF_ORIGINAL_FIELD_OFFSET = 20
export const DEFAULT_TRACECOUNT = 15
export const TRACE_HEADER_SIZE = 240
export const NUMBER_OF_SAMPLES_IN_THIS_TRACE_OFFSET = 114

export const NUMBER_OF_SAMPLES_PER_DATA_TRACE_OFFSET = 20
export const SAMPLE_INTERVAL_OFFSET = 16
export const FORMAT_CODE_OFFSET = 24

export const TRACE_SOURCE_X_OFFSET = 72
export const TRACE_SOURCE_Y_OFFSET = 76
export const TRACE_SOURCE_ILINE_OFFSET = 4
export const TRACE_SOURCE_XLINE_OFFSET = 20

export const TRACE_CDP_X_OFFSET = 180
export const TRACE_CDP_Y_OFFSET = 184
export const TRACE_CDP_ILINE_OFFSET = 188
export const TRACE_CDP_XLINE_OFFSET = 192

export const TRACE_DELAYRECORDINGTIME = 108

export const MAX_START_RECORD_VALUE = 1000
